export default __webpack_public_path__ + "static/media/icon-exercise.3e7b0282.svg";